import { WifiTime } from './wifi-time';

export class TimesControlData {
    weekdays: string[] = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

    constructor(public active: boolean, public times: WifiTime[]) { }
}
